import { FORM_COLOR } from '@app/constant/ColorDefault'
import { CODE_LIMIT } from '@app/constant/LimitConstant'
import { ADMIN_ROUTE } from '@app/constant/RouteConstant'
import { yupResolver } from '@hookform/resolvers/yup'
import { Inertia } from '@inertiajs/inertia'
import { InertiaLink, usePage } from '@inertiajs/inertia-react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Modal from '@mui/material/Modal'
import Paper from '@mui/material/Paper'
import Snackbar from '@mui/material/Snackbar'
import { styled } from '@mui/material/styles'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Translation } from 'react-i18next'
import * as Yup from 'yup'
import VoucherCodeHistory from './VoucherCodeHistory'
import VoucherDetail from './VoucherDetail'
import VoucherPos from './VoucherPos'
const BoxCustom = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  border: `1px solid ${FORM_COLOR.BORDER_BOX}`,
  padding: '25px',
  background: 'white',
})

const VoucherShow = () => {
  const {
    props: { tab, voucher, routeName },
  } = usePage()
  const validateCode = Yup.object().shape({
    codeAmount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_CODE')}</Translation>)
      .integer(<Translation>{(t) => t('VALIDATE.INTEGER_CODE')}</Translation>)
      .min(
        CODE_LIMIT.MIN_CODE,
        <Translation>{(t) => t('VALIDATE.MIN_CODE', { param: CODE_LIMIT.MIN_CODE })}</Translation>
      )
      .max(
        CODE_LIMIT.MAX_CODE,
        <Translation>{(t) => t('VALIDATE.MAX_CODE', { param: CODE_LIMIT.MAX_CODE })}</Translation>
      ),
  })

  const initialValues = {
    codeAmount: '',
  }

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    defaultValues: initialValues,
    resolver: yupResolver(validateCode),
  })

  Inertia.on('finish', () => handleCloseGenerate())

  const onSubmit = (values) => {
    Inertia.post(route(ADMIN_ROUTE.VOUCHER_AMOUNT_MODIFY, { voucher: voucher.id }), values, {})
  }

  const { t } = useTranslation()

  const [openGenerate, setOpenGenerate] = useState(false)

  const handleCloseGenerate = () => {
    reset()
    setOpenGenerate(false)
  }

  const [openSnack, setOpenSnack] = useState(false)

  const handleCloseSnack = () => {
    setOpenSnack(false)
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          autoHideDuration={6000}
          open={openSnack}
          onClose={handleCloseSnack}
        ></Snackbar>
        <VoucherDetail setOpenGenerate={setOpenGenerate} voucher={voucher} />

        <Modal open={openGenerate} onClose={handleCloseGenerate}>
          <BoxCustom component="form" onSubmit={handleSubmit(onSubmit)}>
            <Typography component="h2" sx={{ mb: '10px' }} variant="h6">
              {t('VOUCHER.ADD_CODE')}
            </Typography>
            <TextField
              fullWidth
              required
              error={!!errors.codeAmount}
              helperText={errors.codeAmount?.message}
              name="codeAmount"
              placeholder={t('VOUCHER.ENTER_CODE_NUMBER')}
              size="small"
              type="number"
              variant="outlined"
              {...register('codeAmount')}
            />
            <Button color="primary" sx={{ mt: '20px' }} type="submit" variant="contained">
              {t('VOUCHER.ADD')}
            </Button>
          </BoxCustom>
        </Modal>
      </Grid>
      {routeName && (
        <Grid item xs={12}>
          <Paper variant="outlined">
            <Tabs
              indicatorColor="primary"
              sx={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}
              textColor="primary"
              value={'code_histories' === tab ? 0 : 1}
            >
              <Tab
                preserveScroll
                component={InertiaLink}
                href={route(routeName, {
                  merchant: voucher.merchant_id,
                  voucher: voucher.id,
                  tab: 'code_histories',
                })}
                label={t('VOUCHER.CODE_HISTORY')}
              />
              <Tab
                preserveScroll
                component={InertiaLink}
                href={route(routeName, {
                  merchant: voucher.merchant_id,
                  voucher: voucher.id,
                  tab: 'pos',
                })}
                label={t('VOUCHER.POS')}
              />
            </Tabs>
            {'code_histories' === tab ? <VoucherCodeHistory /> : <VoucherPos />}
          </Paper>
        </Grid>
      )}
    </Grid>
  )
}

export default VoucherShow
